// Бутоните в края на реда в справка: „Печат" и „⋯" с менюто (Принтирай ·
// Преглед · PDF · Excel · [Коригирай · Анулирай]). Менюто е antd Dropdown —
// Esc го затваря, клавиатурата върви по елементите му, а общият пазач за
// отворен слой го вижда. Кликът по бутоните НЕ отваря реда.
import { Dropdown, type MenuProps } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ROW_ICON_BUTTON } from "./density";

// „Печат" в ниския ред — същата височина като „⋯" (ROW_ICON_BUTTON)
const ROW_PRINT_BUTTON = "h-6 px-2 pointer-coarse:h-9 pointer-coarse:px-3";

export type RowAction = {
  key: string;
  label: string;
  hint?: string;
  danger?: boolean;
  // Разделител ПРЕДИ елемента
  dividerBefore?: boolean;
  onClick: () => void;
};

type Props = {
  actions: RowAction[];
  onPrint?: () => void;
  // Карта на телефон: само „⋯", голям за пръст
  compact?: boolean;
  // Ниските редове на справките (34px): бутоните са 24px с мишка, а с пръст
  // (таблет в landscape е „десктоп") — 36px, над минимума за докосване
  dense?: boolean;
};

export const RowActionsMenu = ({ actions, onPrint, compact = false, dense = false }: Props) => {
  const { t } = useTranslation();
  const items: MenuProps["items"] = [];
  for (const action of actions) {
    if (action.dividerBefore) items.push({ type: "divider" });
    items.push({
      key: action.key,
      danger: action.danger,
      label: action.hint ? (
        <span className="flex flex-col gap-0.5 py-0.5">
          <span>{action.label}</span>
          <span className="text-xs text-muted">{action.hint}</span>
        </span>
      ) : (
        action.label
      ),
    });
  }
  return (
    <div
      className="flex items-center justify-end gap-1.5"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      {onPrint && !compact && (
        <button
          type="button"
          onClick={onPrint}
          className={`inline-flex cursor-pointer items-center whitespace-nowrap rounded-[7px] border border-shade-3 bg-surface leading-[normal] text-ink outline-none hover:border-shade-5 focus-visible:shadow-[0_0_0_3px_var(--color-brand-tint)] ${
            dense ? `${ROW_PRINT_BUTTON} text-xs` : "px-2.5 py-[5px] text-[12.5px]"
          }`}
        >
          {t("inventoryPage.printShort")}
        </button>
      )}
      <Dropdown
        trigger={["click"]}
        placement="bottomRight"
        menu={{
          items,
          onClick: ({ key, domEvent }) => {
            domEvent.stopPropagation();
            actions.find((action) => action.key === key)?.onClick();
          },
        }}
      >
        <button
          type="button"
          aria-label={t("inventoryPage.rowMenu")}
          className={`flex cursor-pointer items-center justify-center rounded-[7px] border border-shade-3 bg-surface text-ink outline-none hover:border-shade-5 focus-visible:shadow-[0_0_0_3px_var(--color-brand-tint)] ${
            compact ? "h-9 w-11" : dense ? ROW_ICON_BUTTON : "h-[30px] w-8"
          }`}
        >
          <MoreOutlined />
        </button>
      </Dropdown>
    </div>
  );
};

export default RowActionsMenu;
